<template>
  <div class="flex flex-row border-b border-gray-200 px-4 py-5 sm:px-6
        justify-center items-center">
    <div class="flex flex-col">
      <div class="flex flex-row items-center justify-center mb-5">
        <div class="inline-flex px-2 w-full justify-end">
          <button
            v-show="currentScreen > 1"
            type="button"
            class="w-auto px-4 py-1 border border-transparent text-xs leading-2 font-medium
              rounded-md text-gray-300 bg-white hover:text-gray-200 focus:outline-none
              active:text-gray-500 focus:text-gray-300 transition ease-in-out duration-150"
            @click="$emit('prevScreen')"
          >
            &#60;&#45; Back
          </button>
        </div>
        <div class="inline-flex px-2 w-auto">
          <p class="text-center text-sm text-gray-500 whitespace-no-wrap py-1 leading-2">
            {{ currentScreenString }}
          </p>
        </div>
        <div class="inline-flex w-full px-2">
          <button
            v-show="currentScreen < totalScreens"
            type="button"
            class="w-auto px-4 py-1 border border-transparent text-xs leading-2 font-medium
              rounded-md text-gray-300 bg-white hover:text-gray-200 focus:outline-none
              active:text-gray-500 focus:text-gray-300 transition ease-in-out duration-150"
            :class="{'opacity-25': nextDisabled}"
            :disabled="nextDisabled"
            @click="$emit('nextScreen')"
          >
            Next &#45;&#62;
          </button>
        </div>
      </div>
      <div class="flex flex-row h-20 items-center justify-center">
        <transition name="fade-fast" appear mode="out-in">
          <h1
            class="text-3xl leading-8 font-bold tracking-tight text-gray-900 sm:text-4xl
          sm:leading-10 inline-block text-center"
            :key="currentTitle"
          >
            {{ currentTitle }}
          </h1>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingHeader',
  props: {
    currentScreenString: {
      type: String,
      default: () => '',
    },
    currentTitle: {
      type: String,
      default: () => '',
    },
    currentScreen: {
      type: Number,
      default: () => 1,
    },
    totalScreens: {
      type: Number,
      default: () => 1,
    },
    nextDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>
